<template>
    <div>
        <card-header title="Review" icon="fa-file-signature"/>

        <card-body>
            <card-list>
                <navigation-list-item
                    title="Recent Reviews"
                    icon="fa-timer"
                    @click="$openCard('recent-reviews', {}, card)"
                    v-if="currentUser.isSuper"
                ></navigation-list-item>
<!--                <review-tile-->
<!--                    :card="card"-->
<!--                    :review="c"-->
<!--                    v-for="c in courses"-->
<!--                    @click="$openCard('view-review', {reviewId: c.id}, card)"-->
<!--                    :active="child && child.definition.component === 'view-review' && child.props.reviewId == c.id"-->
<!--                />-->
<!--                <separator-list-item/>-->

<!--                <card-list-item-->
<!--                    @click="$openCard('view-review', {reviewId: conf.id}, card)"-->
<!--                    :class="{'active': child && child.definition.component === 'view-review' && child.props.reviewId == conf.id}"-->
<!--                    v-for="conf in confs" v-if="conf.config.progress === 3"-->
<!--                >-->
<!--                    <template v-slot:icon><i class="far fa-users-class fa-fw"></i></template>-->
<!--                    <template v-slot:content>-->
<!--                        <div class="meta">Washington State Professional Development (Clock Hours)</div>-->
<!--                        <div class="tile-title">{{conf.user.first_name}} {{conf.user.last_name}}</div>-->
<!--                        <div class="tile-title">{{conf.conference.title}}</div>-->
<!--                        <div class="meta mt-1">{{conf.updated_at | moment('MMMM Do, h:mm A')}}, {{conf.registration.clock_hours}} Clock Hours</div>-->
<!--                    </template>-->
<!--                </card-list-item>-->

                <template v-if="reviews.enroll_applications && reviews.enroll_applications.length">
                    <subheader-list-item title="Enrollment Applications" icon="fa-file-certificate" :badge="reviews.enroll_applications.length"/>

                    <card-list-item
                        @click="$openCard('view-enroll-application', {reviewId: app.id}, card)"
                        :class="{'active': child && child.definition.component === 'view-application' && child.props.reviewId == app.id}"
                        v-for="app in reviews.enroll_applications"
                    >
                        <template v-slot:icon><i class="far fa-file-certificate fa-fw"></i></template>
                        <template v-slot:content>
                            <div class="meta">{{app.course_applications.applications.title}}</div>
                            <div class="tile-title">{{app.users.first_name}} {{app.users.last_name}}</div>
                            <div class="tile-title">{{app.enrollments.courses.title}}</div>
                            <div class="meta mt-1">{{app.updated_at | moment('MMMM Do, h:mm A')}}, {{app.total_units}} of {{app.course_applications.max_units}} {{app.course_applications.applications.certification_certs.certifications.unit_title}}</div>
                        </template>
                    </card-list-item>
                </template>

                <template v-if="reviews.reg_applications && reviews.reg_applications.length">
                    <subheader-list-item title="Registration Applications" icon="fa-file-certificate" :badge="reviews.reg_applications.length"/>

                    <card-list-item
                        @click="$openCard('view-application', {reviewId: app.id}, card)"
                        :class="{'active': child && child.definition.component === 'view-application' && child.props.reviewId == app.id}"
                        v-for="app in reviews.reg_applications"
                    >
                        <template v-slot:icon><i class="far fa-file-certificate fa-fw"></i></template>
                        <template v-slot:content>
                            <div class="meta">{{app.conf_application.application.title}}</div>
                            <div class="tile-title">{{app.user.first_name}} {{app.user.last_name}}</div>
                            <div class="tile-title">{{app.conference.title}}</div>
                            <div class="meta mt-1">{{app.updated_at | moment('MMMM Do, h:mm A')}}, {{app.total_units}} of {{app.conf_application.max_units}} {{app.conf_application.certification.unit_title}}</div>
                        </template>
                    </card-list-item>
                </template>

                <template v-if="reviews.conf_applications && reviews.conf_applications.filter(app => app.updated_at).length">
                    <subheader-list-item title="Conference Certification Applications" icon="fa-file-certificate" :badge="reviews.conf_applications.filter(app => app.updated_at).length"/>

                    <card-list-item
                        @click="$openCard('view-conf-application', {confAppId: app.id, confId: app.conferences.id}, card)"
                        :class="{'active': child && child.definition.component === 'view-conf-application' && child.props.confAppId == app.id}"
                        v-for="app in this.reviews.conf_applications.filter(app => app.updated_at)"
                    >
                        <template v-slot:icon><i class="far fa-file-certificate fa-fw"></i></template>
                        <template v-slot:content>
                            <div class="tile-title">{{app.applications.title}}</div>
                            <div class="meta">{{app.conferences.title}}</div>
                            <div class="meta mt-1">Updated {{app.updated_at | moment('MMMM Do')}}, {{app.max_units}} {{app.applications.certification_certs.certifications.unit_title}}</div>
                        </template>
                    </card-list-item>
                </template>

                <template v-if="reviews.course_applications && reviews.course_applications.filter(app => app.updated_at).length">
                    <subheader-list-item title="Course Certification Applications" icon="fa-file-certificate" :badge="reviews.course_applications.filter(app => app.updated_at).length"/>

                    <card-list-item
                        @click="$openCard('view-course-application', {courseAppId: app.id, courseId: app.courses.id}, card)"
                        :class="{'active': child && child.definition.component === 'view-course-application' && child.props.courseAppId == app.id}"
                        v-for="app in this.reviews.course_applications.filter(app => app.updated_at)"
                    >
                        <template v-slot:icon><i class="far fa-file-certificate fa-fw"></i></template>
                        <template v-slot:content>
                            <div class="tile-title">{{app.applications.title}}</div>
                            <div class="meta">{{app.courses.title}}</div>
                            <div class="meta mt-1">Updated {{app.updated_at | moment('MMMM Do')}}, {{app.max_units}} {{app.applications.certification_certs.certifications.unit_title}}</div>
                        </template>
                    </card-list-item>
                </template>


            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import {client as http} from "@/http_client";
    import ReviewTile from "../../components/tiles/ReviewTile";
    import async from "async";
    import CardListItem from "../../TIER/components/CardListItem";
    import Toolbar from "../../TIER/components/Toolbar";
    import {mapActions, mapGetters} from "vuex";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem.vue";
    import NavigationListItem from "../../TIER/components/NavigationListItem.vue";

    export default {
        components: {NavigationListItem, SubheaderListItem, Toolbar, CardListItem, ReviewTile, CardToolbar, SeparatorListItem, CardHeader, CardBody, CardList},
        props: ['card', 'child'],
        data() {
            return {
                courses: [],
                confs: [],
                apps: []
            };
        },
        computed: {
            ...mapGetters(['reviews', 'currentUser'])
        },
        methods: {
            ...mapActions(['getReviews']),
            load: function() {
                this.getReviews().then(() => {
                    this.$emit('loading', false);
                });
            },
            reload: function() {
                this.load();
            }
        },
        mounted: function() {
            this.load();
        }
    };
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
